export class Enumeration {
    public id: number = 0;
    public name: string = '';
}

export class WorksLocationReply {
    public worksLocations: Enumeration[] = [];
}

export class PhaseTypeReply {
    public phaseTypes: Enumeration[] = [];
}

export class TmTypeReply {
    public tmTypes: Enumeration[] = [];
}

export class FwClosureReply {
    public fwClosures: Enumeration[] = [];
}

export class PermitStatusReply {
    public permitStatuses: Enumeration[] = [];
}

export class NoticeStatusReply {
    public noticeStatuses: Enumeration[] = [];
}

export class NoticeFileTypeReply {
    public fileTypes: Enumeration[] = [];
}

export class PermitTypesReply {
    public permitTypes: Enumeration[] = [];
}

export class RoadTypesReply {
    public roadTypes: Enumeration[] = [];
}

export class CancelReasonReply {
    public cancelReasons: Enumeration[] = [];
}

export class SubResourcesReply {
    public subResources: Enumeration[] = [];
}

export class RegStatusReply {
    public registrationStatuses: Enumeration[] = [];
}

export class SenstiveHoursReply {
    public sensitiveHoursOptions: Enumeration[] = [];
}